module.exports = __webpack_public_path__ + "img/res10.da6d2c96.gif";